"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAddress = exports.validateAddressMessage = void 0;
exports.validateAddressMessage = "Address should start with m and have a minimum of 50 characters";
function validateAddress(val) {
    return ((/^m[0-9a-z]*$/.test(val) && val.length >= 50) || exports.validateAddressMessage);
}
exports.validateAddress = validateAddress;
